<template>
   <div class="container">
     <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="secondary"
    >
      {{message}}
    </b-alert>
    <b-overlay
          id="overlay-background"
          :variant="variant"
          :opacity="opacity"
          :blur="blur"
          :show="show"
          :rounded="rounded"
          :isLoading="isLoading"
          no-wrap
        ></b-overlay>
        <div class="container" v-if="!show">
          <div class="card-head">
        <img class="img1" src="../assets/Icon/add patient data.svg">
            DATA PASIEN 
    </div>

    <div class="row">
      <div class="col-6">          
            <b-button class="btn btn-info text-black" @click="addpatient()">TAMBAH PASIEN <b-icon icon="plus"></b-icon></b-button>
        </div>
        <div class="col-6">
      <div class="d-flex input-group mb-3">
         <input type="search" class="form-control" placeholder="Search Name" v-model="keyword">
         <button class="input-group-text" @click="searchItem()"><img class="img11" src="../assets/search.png"></button>
      </div>
    </div>
    </div>
    <table class="table">
      <thead>
        <tr class="lightdark-a">
          <th scope="col">Kode Pasien</th>
          <th scope="col">Nama Pasien</th>
          <th scope="col">NIK</th>
          <th scope="col">Golongan Darah</th>
          <th scope="col">Tanggal Lahir</th>
          <th scope="col">Jenis Kelamin</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
    <div v-if="totalRows == 0" class="d-flex justify-content-center"><b-icon icon="x-lg" variant="danger"></b-icon><p>data tidak ditemukan :(</p></div>
        <tr v-for="user in searchItem" :key="user.id" id="my-table" class="lightdark-b ">
          <td scope="row">{{user.patient_code}}</td>
          <td scope="row">{{user.full_name}}</td>
          <td scope="row">{{user.national_id}}</td>
          <td scope="row">{{user.bloodtype}}</td>
          <td scope="row">{{user.birthdate}}</td>
          <td scope="row">{{user.gender}}</td>
          <td><button @click="redirect(user.id)" v-b-popover.hover.top="'Edit'" class="btn-success w100 btn"><b-icon icon="pencil-square"></b-icon></button>
              <button @click="hapus(user.id)" v-b-popover.hover.top="'Hapus'" class="btn w100 btn-danger"><b-icon icon="trash"></b-icon></button></td>
        </tr>
      </tbody>
    </table>
        <div class="d-flex my-2 ">
        <p class="mx-4">Page {{currentPage}} of {{totalPage}}</p>    
        <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
              label-next-page="nextPage"
              label-prev-page="prevPage"
            >
            </b-pagination>        
            </div>
      </div>
    </div> 
</template>

<script>
import axios from 'axios';
export default {
    name: "patientData",
    computed: {
      searchItem(){              
        const filter = this.keyword
              ? this.items.filter(item => item.full_name.toLowerCase().includes(this.keyword.toLowerCase()))
              : this.listItem
              console.log(this.listItem)
              return filter
      },
        totalRows() {
        return this.items.length
        }, 
        totalPage() {
            const x = this.perPage
            const y = this.totalRows
            const z = y / x  
            return Math.floor(z) + 1       
            },
                listItem() {
                    return this.items.slice(
                    (this.currentPage - 1) * this.perPage,
                    this.currentPage * this.perPage,
              )
		}
  },
    data(){
      return{
        items: [],
        message: '',
        showTop: false,
        perPage: 5,
        currentPage: 1,
        keyword: '',
        variant: 'transparent',
        opacity: 0.85,
        blur: '5px',
        isLoading: true,
        show: false,
        rounded: 'lg',
        showModal: false,
        hapusData: false,
        search: false,
      }
    },
    methods: {
      addpatient() {
          this.$router.push('/addpatient');
        },
      redirect(id) {
              this.$router.push('editpatient/' + id);
              console.log(id)
              },
      hapus(id){
        const data = {
          id : id
        }
        axios.delete(`patient/delete/${id}`, data)
      .then(response => {
        console.log(response)
        const messageTrue = "Data Berhasil Terhapus"
        this.$localStorage.set('messagePatient', messageTrue)
        location.reload()
      })
      .catch(error => {
        console.log(error.response.data.error)
        const errorinput = error.response.data.error
        if(error){
              this.message = errorinput
              this.showTop = true,
              // this.toggleLength = true
              setTimeout(() => {
            this.showTop = false;
            // this.toggleLength = false
                  }, 2000);
        }
      })
      }
    },
    async mounted(){
         try {
              const response = await axios.get('patient');
            this.items = response.data.patient;
              console.log(response.data)
            } catch(e) {
              console.log(e);
            }
  const message = this.$localStorage.get('messagePatient')
    if(message){
                this.message = message
                this.show = true;
               this.showTop = true
              setTimeout(() => {
                this.show = false
            this.showTop = false;
            localStorage.removeItem('messagePatient');
                  }, 2000);
    }
  }
}
</script>

<style scoped>

.w100 {
  width: 100%;
}

.table {
  text-align: center;
    }
.lightdark-a {
  background-color: #DDDDDD;
;

;
}
.lightdark-b {
background-color: #F3F3F3;

;
}
.img1{
    height:50px;
    width:50px;

}
.card-head{
    font-size: 20px;
    margin-top: 1.5rem;
    margin-bottom: 60px;
}

.card-body{
    width: auto;
    height:auto;
    margin: 2rem auto;
    background:#F3F3F3;;
    padding-bottom: 3px;
}
.btn{
    
    /* height: 33px; */
    width: auto;
    margin-left: 5px;
    margin-right: 5px;
    /* background: #794B93; */
}
.input-group{
margin-left: 180px;
    width: 300px;
}

.search{
    margin-left:41rem ;
}

.img11{
    height:15px;
    width:15px; 
}
.search{
    margin-left:41rem ;
}


</style>


